import { resetLoadPreviousMessagesError } from '../../messages/messagesSlice';
import { resetScrollToMessageError } from '../chatSlice';

const resetChatErrors = () => (dispatch) => {
  dispatch(resetScrollToMessageError());
  dispatch(resetLoadPreviousMessagesError());
};

export default resetChatErrors;
